<template>
  <Listbox as="div" v-model="selected">
    <ListboxLabel class="block text-sm font-medium text-gray-700">{{ label }}</ListboxLabel>
    <div class="mt-1 relative">
      <ListboxButton
        data-cy="select-clinician"
        class="
          relative
          w-full
          bg-white
          border border-gray-300
          rounded-md
          shadow-sm
          pl-3
          pr-10
          py-1.5
          text-left
          cursor-default
          focus:outline-none
          focus:ring-1 focus:ring-vice-teal-500
          focus:border-vice-teal-500
          sm:text-sm
        "
      >
        <span class="flex items-center">
          <ViceAvatar :image="selected.profile_photo_url" :name="selected.name" class="w-6 h-6" />
          <span class="ml-3 block truncate">{{ selected.name }}</span>
        </span>
        <span
          class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
          style="margin-right: 1px"
        >
          <SelectDropdownArrow class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>

      <transition
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="
            absolute
            z-10
            mt-1
            w-full
            bg-white
            shadow-lg
            max-h-56
            rounded-md
            py-1
            text-base
            ring-1 ring-black ring-opacity-5
            overflow-auto
            focus:outline-none
            sm:text-sm
          "
        >
          <ListboxOption
            as="template"
            v-for="option in options"
            :key="option.id"
            :value="option"
            v-slot="{ active, selected }"
          >
            <li
              @click="$emit('optionSelected', option)"
              :class="[
                active ? 'text-white bg-vice-teal-600' : 'text-gray-900',
                'cursor-default select-none relative py-2 pl-3 pr-9',
              ]"
            >
              <div class="flex items-center">
                <ViceAvatar :image="option.profile_photo_url" :name="option.name" class="w-7 h-7" />
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                  {{ option.name }}
                </span>
              </div>

              <span
                v-if="selected"
                :class="[
                  active ? 'text-white' : 'text-vice-teal-600',
                  'absolute inset-y-0 right-0 flex items-center pr-4',
                ]"
              >
                <CheckIcon class="h-5 w-5" aria-hidden="true" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import {
  Listbox,
  ListboxButton,
  ListboxLabel,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue';
import { CheckIcon } from '@heroicons/vue/solid';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';
import SelectDropdownArrow from '@/Components/Icons/SelectDropdownArrow.vue';

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    ViceAvatar,
    SelectDropdownArrow,
  },
  props: {
    label: String,
    options: Object,
    selectedOption: Number,
  },
  data() {
    return {
      selected:
        this.options.filter((value) => value.id == this.selectedOption)[0] ?? this.options[0],
    };
  },
};
</script>
